import { getLocalStorage } from 'helpers/storage';
import { toNumericValue } from 'helpers/currency';

export const getProductBasePrice = (item = {}, talles = []) => {
  const directPrice = toNumericValue(item.price);
  if (directPrice > 0) return directPrice;

  const variantPrices = [
    ...(talles || []).map((talle) => talle?.price),
    ...(item.stock_product_descriptions || []).map((description) => description?.price),
  ]
    .map(toNumericValue)
    .filter((price) => price > 0);

  return variantPrices.length > 0 ? Math.min(...variantPrices) : 0;
};

export const getPercentageOrAmount = ({ coupon, subtotal }) => {
  if (!coupon) return 0;
  const { amount, percentage } = coupon;
  return percentage ? (percentage / 100) * subtotal : amount;
};

export const getTotalValueWithoutDiscount = ({ coupon, subtotal }) => {
  const percentageOrAmount = getPercentageOrAmount({ coupon, subtotal });
  return (subtotal - percentageOrAmount) > 0 ? subtotal - percentageOrAmount : 0;
};

export const getTotalValueWithDiscount = ({ coupon, discount, subtotal }) => {
  const percentageOrAmount = getPercentageOrAmount({ coupon, subtotal });
  return (discount - percentageOrAmount) > 0 ? discount - percentageOrAmount : 0;
};

export const getTotalValueWithPercetage = ({ coupon, subtotal }) => {
  const percentageOrAmount = getPercentageOrAmount({ coupon, subtotal });
  return subtotal - percentageOrAmount;
};

export const getTotalAmount = ({ coupon, subtotal }) => {
  const discount = getLocalStorage('discount');
  if (!discount) return getTotalValueWithoutDiscount({ coupon, subtotal });
  return coupon?.percentage
    ? getTotalValueWithPercetage({ coupon, subtotal })
    : getTotalValueWithDiscount({ coupon, discount, subtotal });
};


/**
 * Calcula el precio por metro según los tramos definidos
 * @param {number} quantity - Cantidad total de metros
 * @param {number} basePrice - Precio base del producto
 * @param {Array} stockDescriptions - Lista de descripciones con nombre como medida y precio
 * @returns {number} - Precio unitario aplicado según tramo
 */
export function getUnitPriceFromQuantity(quantity, basePrice, stockDescriptions = []) {
  if (!quantity || quantity <= 0) return 0;

  const tiers = (stockDescriptions || [])
    .filter((desc) => {
      if (!desc || !desc.stock_descriptions) return false;
      const name = desc.stock_descriptions.name;
      return name && !isNaN(parseFloat(name));
    })
    .map((desc) => ({
      min: parseFloat(desc.stock_descriptions.name),
      price: desc.price
    }))
    .sort((a, b) => a.min - b.min);

  // Siempre incluir el precio base como tramo inicial
  tiers.unshift({ min: 0, price: basePrice });

  // Buscar el tramo más alto que cumpla
  for (let i = tiers.length - 1; i >= 0; i--) {
    if (quantity >= tiers[i].min) {
      return tiers[i].price;
    }
  }

  return basePrice;
}



/**
 * Calcula el precio total por cantidad y tramos de medida
 * @param {number} quantity - Total de metros
 * @param {number} basePrice - Precio base del producto
 * @param {Array} stockDescriptions - Lista de tramos con medida y precio
 * @returns {number} - Precio total para esa cantidad
 */
export function getTotalPriceFromQuantity(quantity, basePrice, stockDescriptions = []) {
  const unitPrice = getUnitPriceFromQuantity(quantity, basePrice, stockDescriptions);
  return quantity * unitPrice;
}

export const getTextilQuantityAndTotal = (item, fallbackQuantity = 0) => {
  if (!item) return { quantity: 0, total: 0, unitPrice: 0 };

  const quantity = Number(fallbackQuantity) || 0;

  const unitPrice = getUnitPriceFromQuantity(
    quantity,
    item.price,
    item.stock_product_descriptions || []
  );

  const total = getTotalPriceFromQuantity(
    quantity,
    unitPrice,
    item.stock_product_descriptions || []
  );

  return { quantity, total, unitPrice };
};
